import * as TYPE from './mutation-types';
import wordEnding from '@/utils/wordEnding';

export default {
  [TYPE.COUNT_CITY_CARS](state, value) {
    const countCityCarsElement = document.querySelector('.count-city-cars');

    state.countCityCars = value;
    if (countCityCarsElement) {
      countCityCarsElement.innerHTML = value;
    }
  },
  [TYPE.COUNT_OTHER_CARS](state, value) {
    const countOtherCarsElement = document.querySelector('.count-other-cars');
    const textOtherCarsElement = document.querySelector('.count-other-cars + span');

    state.countOtherCars = value;
    if (countOtherCarsElement) {
      countOtherCarsElement.innerHTML = value;
      textOtherCarsElement.innerHTML = `&nbsp;${wordEnding(value, ['автомобиль', 'автомобиля', 'автомобилей'])}`;
    }
  },
  [TYPE.LAST_PAGE](state, value) {
    state.lastPage = value;
  },
  [TYPE.FILTER_CARS](state, value) {
    state.filterCars = value;
  },
  [TYPE.FILTER_PARAMS](state, value) {
    state.filterParams = value;
  },
  [TYPE.WAIT_FOR_REQUEST_FILTER_PARAMS](state, value) {
    state.waitForRequestFilterParams = value;
  },
  [TYPE.SELECTED_DATA](state, value) {
    state.selectedData = value;
  },
};
